import React, { useState, useEffect } from "react";
import { Typography, Switch, Box } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { mandatoryFields } from '../../redux/actions/assetActions';
import { SuccessChips, ErrorChips, WarningChips } from '../../assets/styled-components/chips';
import { getAuthToken } from "../../utility/tokenUtility";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import axios from "axios";
const ComponentHeader = ({
  mainHeader,
  subHeader,
  requiredButton,
  hospitalLabel,
  assetvalue,
  statusType
}) => {

  const dispatch = useDispatch();
  const status = useSelector((state) => state?.workOrderStatus?.status);
  const mandatoryRequiredButton = useSelector((state) => state.mandatoryFields.isMandatoryRequiredEnabled);
  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString(); // Format: MM/DD/YYYY
    const formattedTime = currentDate.toLocaleTimeString(); // Format: HH:MM:SS AM/PM
    return `${formattedDate} ${formattedTime}`;
  };

  const handleSwitchChange = (event) => {
    // Access the checked state of the switch using event.target.checked
    const isChecked = event.target.checked ? true : false;
    // Perform actions based on the switch state (isChecked)
    dispatch(mandatoryFields(isChecked, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
  };


  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant='title2' color={"text.secondary"}>
          {mainHeader}
          {assetvalue && ` - ${assetvalue}`}
        </Typography>


        <Box>


          {requiredButton && (
            <>
              {" "}
              <Switch

                inputProps={{ 'aria-label': 'required-only' }}
                size="small"
                onChange={handleSwitchChange}
                checked={mandatoryRequiredButton}
              />
              <Typography mx={1} component={"span"}>
                Required Only
              </Typography>
            </>
          )}

          {statusType === "open" ? (<ErrorChips label='Open' />) :
            statusType === "closed" ? (<ErrorChips label='Closed' />) :
              statusType === "inprogress" ? (<WarningChips label='In Progress' />) :
                statusType === "cancelled" ? (<ErrorChips label='Cancelled' />) :
                  statusType === "authorized" ? (<SuccessChips label='Authorized' />) :
                    statusType === "unauthorized" ? (<ErrorChips label='Unauthorized' />) :
                      statusType === "submitted" ? (<SuccessChips label='Submitted' />) :
                        statusType === "rejected" ? (<ErrorChips label='Rejected' />) :
                          statusType === '' ? '' : // it is handling empty status type
                            status === "Open" ? (<ErrorChips label='Open' />) :
                              status === "Scheduled" ? (<ErrorChips label='Scheduled' />) :
                                status === "Closed" ? (<SuccessChips label='Closed' />) :
                                  status === "Completed" ? (<SuccessChips label='Completed' />) :
                                    status === "In Progress" ? (<WarningChips label='In Progress' />) :
                                      status === "Cancelled" ? (<ErrorChips label='Cancelled' />) :
                                        status === "Verified" ? (<SuccessChips label='Verified' />) : 
                                          status === "Not Done and Closed" ? (<ErrorChips label='Not Done and Closed' />) : 
                                            status === "In Progress-Outsource" ? (<WarningChips label='In Progress-Outsource' />) : 
                                              status === "Completed-Outsource" ? (<SuccessChips label='Completed-Outsource' />) : null}
        </Box>
      </Box>
      <Typography color="text.primary">{subHeader}</Typography>

    </>
  );
};

export default ComponentHeader;
